import Input from '../../../components/Input/Input';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { DialogClose, DialogFooter } from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';
import { emailScheme } from 'src/utils/validation-schemes';

export const ResetPasswordForm = ({ submit }: { submit: (email: string) => void }) => {
  const {
    control,
    trigger,
    handleSubmit,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(
      object({
        email: emailScheme({ required: true }).label('Email'),
      }),
    ),
  });

  const submitFunc = (value: { email: string }) => {
    submit(value.email);
  };

  return (
    <>
      <form id="reset-password-form" onSubmit={handleSubmit(submitFunc)}>
        <div className={'input-container'}>
          <p className="text-ebony_opacity_70 font-medium text-base pb-4 font-jamjuree text-center">
            Enter the email address associated with your CoSupport AI account
          </p>
          <Controller
            control={control}
            name="email"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Input
                type={'text'}
                placeholder="email@email.com"
                invalidMessage={error?.message}
                value={value}
                isValid={!error?.message}
                onChange={onChange}
                onBlur={() => trigger('email')}
              />
            )}
          />
        </div>
      </form>
      <DialogFooter className="w-full !justify-center max-md:flex-row">
        <DialogClose asChild>
          <Button variant="outline" className="flex items-center gap-1 min-h-[34px] min-w-[135px]">
            <p className="font-semibold text-sm font-jamjuree">Cancel</p>
          </Button>
        </DialogClose>
        <Button
          disabled={!isDirty}
          style={{ width: 'auto' }}
          type="submit"
          form="reset-password-form"
          className="min-h-[34px] min-w-[135px] max-md:!ml-2"
        >
          Reset password
        </Button>
      </DialogFooter>
    </>
  );
};
